import get from "lodash/get";

export default state => get(state, "category.breadcrumbs");
